import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        flex: '0 0 auto',
        padding: `${theme.spacing()}px ${theme.spacing(2)}px`,
        borderTop: 'solid 1px #ddd',
    },
});

const BoxActions = ({ classes, className, children }) => (
    <div className={classNames(classes.root, className)}>{children}</div>
);

BoxActions.propTypes = {
    children: PropTypes.node.isRequired,
    classes: PropTypes.object.isRequired,
    className: PropTypes.string,
};

export default withStyles(styles)(BoxActions);
